import { render, staticRenderFns } from "./MenueCard.vue?vue&type=template&id=8cdcac58"
import script from "./MenueCard.vue?vue&type=script&lang=js"
export * from "./MenueCard.vue?vue&type=script&lang=js"
import style0 from "./MenueCard.vue?vue&type=style&index=0&id=8cdcac58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports